module.exports = __webpack_public_path__ + "img/logo.fe1502a9.png";